@let assets = assets$ | async;

@if(assets && showAssetsSelectionDialog && (lorenTourService.getTourRunning$() | async) === false) {
<loren-asset-selection-dialog
  [dialogSubTitle]="'operations.choose_assets_for_reports'"
  [dialogTitle]="'operations.choose_asset'"
  [multiSelection]="false"
  [assets]="assets"
  (finishSelection)="handleAssetsSelection($event)"
  (cancelSelection)="handleAssetsSelectionCancel()">
</loren-asset-selection-dialog>
}